import {getFileSize} from '@/utils/index'
import {generateUUID } from '@/common/utils'
import { calculateMaxFilesOutOfRange } from '@/common/copyright/utils'
import { parseUA } from '@/common/utils.js'
import {opusUserInfo} from '@/api/service'
import { mapState } from 'vuex'
export default {
    data () {
        return {
            upTipcCheck:false,
            upTipDia:false,//本地上传提示框
            fil:{},
            fileType:[
                {
                    name:'商业秘密',
                    value: 109,
                },
                {
                    name:'工业项目',
                    value: 119,
                },
                {
                    name:'软件项目',
                    value: 108,
                    relatedID: 13, //关联ID
                },
                {
                    name:'硬件项目',
                    value: 120,
                },
                {
                    name:'科研成果',
                    value: 121,
                },
                {
                    name:'数据资产',
                    value: 122,
                },
                {
                    name:'商标设计',    
                    value: 123,
                },
                {
                    name:'专利文档',
                    value: 124,
                },
                {
                    name:'文字作品',   
                    value: 101,
                    relatedID: 2, //关联ID
                },
                {
                    name:'摄影作品',
                    value: 110,
                    relatedID: 3, //关联ID
                },
                {
                    name:'美术作品',
                    value: 104,
                    relatedID: 4, //关联ID
                },
                {
                    name:'音乐作品',
                    value: 102,
                    relatedID: 5, //关联ID
                },
                {
                    name:'设计作品',
                    value: 105,
                    relatedID: 6, //关联ID
                },
                {
                    name:'讲义课件',
                    value: 125,
                },
                {
                    name:'视听作品',
                    value: 112,
                    relatedID: 1, //关联ID
                },
                {
                    name:'口述作品',
                    value: 132,
                    relatedID: 7, //关联ID
                },
                {
                    name:'戏剧曲艺作品',
                    value: 133,
                    relatedID: 8, //关联ID
                },
                {
                    name:'舞蹈杂技作品',
                    value: 134,
                    relatedID: 9, //关联ID
                },
                {
                    name:'建筑作品',
                    value: 135,
                    relatedID: 10, //关联ID
                },
                {
                    name:'图形作品',
                    value: 136,
                    relatedID: 11, //关联ID
                },
                {
                    name:'模型作品',
                    value: 137,
                    relatedID: 12, //关联ID
                },
                {
                    name:'其它',
                    value: 999,
                    relatedID: 0, //关联ID
                },
            ],
            opusDescribe:'',
            opusDescribeText:'本作品/文件已经申请可信时间戳认证，「权利人名称」拥有该作品的著作权（包括但不限于发表权、署名权、修改权、保护作品完整权、复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权）和法律授予的其他权利，未经授权，任何单位和个人禁止以任何方式使用本文件。',//自述声明文案

        }
    },
    components: {},
    created () {
        this.opusDescribe=this.opusDescribeText
    },
    watch: {},
    computed: {
        ...mapState({
            opusUserInfo: (state) => state.userInfo.userInfo,
        }),
        isIOS() {
            const ua = parseUA()
            return ua.iPhone || ua.iPad || ua.ios
        },
    },
    mounted () {},
    methods: {
        noDiaLog(e){
            this.$setlocalStorage("opusNoDia",e)
        },
        scrollBlur(){
            if (document.activeElement) {
                document.activeElement.blur();
            }
        },
        // 获取用户信息
        async getUserInfo(retrunApplyName=false) {
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await opusUserInfo()
                    this.attestationInfo = res;
                    this.showNameType=res.showNameType;
                    // 先拉取最新用户数据，防止缓存数据过期
                    await this.$store.dispatch('userInfo/fetchUserInfo')
                    //子账号
                    if(this.opusUserInfo.userType =='AUTHORIZATION_ACCOUNT'){
                        let applyName;
                        if(res.identificationStatus !== 2){//主实名
                            applyName=res.applyName
                        }else{
                            if(res.showNameType==0){//显示主
                                applyName=this.opusUserInfo.masterAccount
                            }else if(res.showNameType==1){//显示主+子
                                applyName=this.opusUserInfo.masterAccount+'-'+this.opusUserInfo.ownerName
                            }else{//2.子
                                applyName=this.opusUserInfo.ownerName
                            }
                        }
                        retrunApplyName ? resolve({applyName}) : this.form.applicant = applyName
                        
                    }else{
                        //主账号用户未实名的
                        if(res.identificationStatus == 2){
                            retrunApplyName ? resolve({applyName:this.opusUserInfo.loginName}) : this.form.applicant = this.opusUserInfo.loginName
                        }else{
                            retrunApplyName ? resolve({applyName:res.applyName}) : this.form.applicant=res.applyName
                        }
                    }
                    if(retrunApplyName){
                        return
                    }
                    resolve()
                } catch (error) {
                    console.log(error)
                    reject()
                }
                
            })
        },
        //拖拽功能
        dragenter(e){
            e.preventDefault();
            e.stopPropagation();
        },
        dragover(e){
            e.dataTransfer.dropEffect = 'copy'; // 兼容某些三方应用，如圈点
            e.preventDefault();
            e.stopPropagation();
        },
        // 转换文件类型 默认 112
        categoryToFileType (category) {
            let obj = this.fileType.find(item => item.relatedID === category)
            return obj ? obj.value : 112
        },
        // 处理文件系统入口（可能是文件或目录）
        // category 用来转化文件类型
        processEntry(entry, category) {
            console.log({
                entry,
                category
            })
            let that=this;
            return new Promise((resolve, reject) => {
                if (entry.isFile) {
                    // 处理单个文件
                    entry.file((file) => {
                        let obj = {
                            fileItem: file,
                            opusName: file.name,
                            fileType: this.categoryToFileType(category),
                            isUploadFile:true,
                            applyRemark:'',
                            modified: false,
                            opusNameCheck: true,
                            opusNameEdit:'',
                            percentage: 0,
                            opusDescribe:this.opusDescribe,
                            id:'',
                            uuid: generateUUID(),
                            serialNo:'',
                            solidifyPercentage: 0, // 固化上传百分比百分比
                            solidifySuccess: 0, // 是否固化完成 // 0 未完成， 1 成功， 2 固化失败
                            ossSliceUploadPercentage: 0, // 分片上传百分比
                            ossSliceUploadSuccess: 0, // 是否分片上传完成 // 0 未完成， 1 成功， 2 上传失败
                            applyFileSize: file.size, // 文件的大小，用来进行存证扣费用的
                            fileSize:getFileSize(file.size),
                            years:this.storageYear || 3 // 存储年限
                        }
                        if(file.size > 1048576){
                            if(Math.floor(file.size==0)){
                                this.$message({
                                    duration:5000,
                                    type: 'error',
                                    message: `文件${file.name}大小为0kb，无法确权，已为您从列表移除。`,
                                })
                                resolve()
                            }else{
                                if(calculateMaxFilesOutOfRange(this.stageList, 'dramaStageFileDraftList')+that.timeData.length==1000){
                                    reject({code:1000})
                                }else{
                                    that.timeData.push(obj);
                                    resolve()
                                }
                            }
                        }else{
                            let reader = new FileReader()
                            if (file.slice) {
                                var blob = file.slice(0, file.size)
                            } else if (file.webkitSlice) {
                                var blob = file.webkitSlice(0, file.size)
                            }
                            reader.readAsArrayBuffer(blob)
                            reader.onload =(e)=>{
                                if(file.size==0){
                                    this.$message({
                                        duration:5000,
                                        type: 'error',
                                        message: `文件${file.name}大小为0kb，无法确权，已为您从列表移除。`,
                                    })
                                    resolve()
                                    return
                                }
                                if(Math.floor(file.size==0)){
                                    this.$message({
                                        duration:5000,
                                        type: 'error',
                                        message: `文件${file.name}大小为0kb，无法确权，已为您从列表移除。`,
                                    })
                                    resolve()
                                }else{
                                    if(calculateMaxFilesOutOfRange(this.stageList, 'dramaStageFileDraftList')+that.timeData.length==1000){
                                        reject({code:1000})
                                    }else{
                                        that.timeData.push(obj);
                                        resolve()
                                    }
                                }
                            }
                            reader.onerror = (e)=> {
                                this.$message({
                                    duration:5000,
                                    type: 'error',
                                    message: '拖动仅支持文件，文件夹请点击“选择文件夹”按钮。',
                                })
                                resolve()
                            }
                        }
                        //resolve()
                    })
                } else if (entry.isDirectory) {
                    // 处理目录
                    this.readDirectory(entry, category).then(resolve).catch(reject)
                }else{
                    resolve()
                }
            })
        },
        // 递归读取目录
        readDirectory(directoryEntry, category) {
            return new Promise((resolve, reject) => {
                const reader = directoryEntry.createReader()
                const readPromises = []
                // 读取目录内容
                const readEntries = () => {
                    reader.readEntries((entries) => {
                        if (entries.length === 0) {
                            Promise.all(readPromises).then((results) => {
                                resolve()
                            }).catch(reject)
                            return
                        }
                        // 处理当前批次的条目
                        entries.forEach(entry => {
                            const promise = this.processEntry(entry, category)
                            readPromises.push(promise)
                        })
                        // 继续读取更多条目
                        readEntries()
                    })
                }
                readEntries()
            })
        },

        //选择文件
        choosefile(from){
            this.$refs.inputer.click();
            this.fileOrFolder=false;
            if(from=='inside'){
                this.$emit('changeOpcity',false)
            }
        },

        //添加文件
        addfile(n,from, category){
            let inputDOM;
            inputDOM = this.$refs.inputer
            let files=inputDOM.files
            this.checkFile(files,from, category)
        },
        //遍历当前上传的文件，为每个文件加相关属性
        forFileList(from, category){
            let that=this;
            let obj;
            if(calculateMaxFilesOutOfRange(this.stageList, 'dramaStageFileDraftList')+this.timeData.length+this.fil.length>1000){
                this.$TsaToastV2.show({
                    message: '最多支持添加1000个文件',
                    type: 'warn'
                })
                return
            }
            for (let i = 0; i < this.fil.length; i++) {
                if(Math.floor(that.fil[i].size==0)){
                    this.$message({
                        duration:5000,
                        type: 'error',
                        message: `文件${that.fil[i].name}大小为0kb，无法确权，已为您从列表移除。`,
                        customClass:'highLevel'
                    })
                }else{
                    obj = {
                        fileItem: this.fil[i],
                        opusName: this.fil[i].name,
                        fileType: this.categoryToFileType(category),
                        isUploadFile:true,
                        applyRemark:'',
                        modified: false,
                        opusNameCheck: true,
                        opusNameEdit:'',
                        percentage: 0,
                        opusDescribe:this.opusDescribe,
                        //新版增加
                        id:'',
                        uuid: generateUUID(),
                        serialNo:'',
                        solidifyPercentage: 0, // 固化上传百分比百分比
                        solidifySuccess: 0, // 是否固化完成 // 0 未完成， 1 成功， 2 固化失败
                        ossSliceUploadPercentage: 0, // 分片上传百分比
                        ossSliceUploadSuccess: 0, // 是否分片上传完成 // 0 未完成， 1 成功， 2 上传失败
                        applyFileSize: this.fil[i].size, // 文件的大小，用来进行存证扣费用的
                        fileSize:getFileSize(this.fil[i].size),
                        years:this.storageYear || 3 // 存储年限
                    }
                    that.timeData.push(obj);
                    if(i==this.fil.length-1){
                        setTimeout(() => {
                            if(from=='inside'){
                                this.init()
                                this.scrollBottom();
                            }else{
                                this.confirmDialog=true;
                            }
                        }, 100);
                    }
                }
            }
        },
        // 检测文件是否符合要求
        checkFile(files,from, category){
            let file=files[0];
            if(file.size > 1048576){
                this.fil = files;
                this.forFileList(from, category);
                if(this.$refs.inputer) this.$refs.inputer.value = null;
            }else{
                let reader = new FileReader()
                if (file.slice) {
                    var blob = file.slice(0, file.size)
                } else if (file.webkitSlice) {
                    var blob = file.webkitSlice(0, file.size)
                }
                reader.readAsArrayBuffer(blob)
                reader.onload =(e)=>{
                    this.fil = files
                    if (this.fil.length == 0) {
                        return false
                    }
                    if(file.size==0){
                        this.$message({
                            duration:5000,
                            type: 'error',
                            message: `文件${file.name}大小为0kb，无法确权，已为您从列表移除。`,
                            customClass:'highLevel'
                        })
                        if(this.$refs.inputer) this.$refs.inputer.value = null;
                        return
                    }
                    this.forFileList(from, category);
                    if(this.$refs.inputer) this.$refs.inputer.value = null;
                }
                reader.onerror = (e)=> {
                    this.$message({
                        duration:5000,
                        type: 'error',
                        message: '拖动仅支持文件，文件夹请点击“选择文件夹”按钮。',
                    })
                    if(this.$refs.inputer) this.$refs.inputer.value = null;
                }
            }
        },
    }
}
